import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "barContainer" }
const _hoisted_2 = { class: "pl-8 pb-2 pt-4" }
const _hoisted_3 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { sm: "10" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_BarChart, {
              id: "speicherBarGraph",
              "chart-data": _ctx.chartdata,
              options: _ctx.options
            }, null, 8, ["chart-data", "options"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('einstellungen.diagramm.tvsbelegung')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.getReadableFileSizeString(_ctx.belegterSpeicher.tvsBelegterSpeicher)), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        sm: "2",
        style: {"margin":"auto"}
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("h4", null, _toDisplayString(_ctx.getReadableFileSizeString(_ctx.maximalerSpeicher)), 1),
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "100%", -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}